import { useWebCoreStore } from '@codes/web-core';

export enum UserRole {
    Owner,
    Member,
    Guest,
    Unknown,
}

export const useMyRole = () => {
    const { profile } = useWebCoreStore();

    if (!profile) {
        return UserRole.Unknown;
    }

    if (profile.$role.role === 'owner') {
        return UserRole.Owner;
    }

    if (profile.$role.role === 'member') {
        return UserRole.Member;
    }

    if (profile.$role.role === 'guest') {
        return UserRole.Guest;
    }

    return UserRole.Unknown;
};
